import React, { useState, useEffect } from "react";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import { 
  UncontrolledPopover, 
  PopoverHeader, 
  PopoverBody, 
  DropdownToggle, 
  DropdownMenu, 
  UncontrolledDropdown, 
  DropdownItem, 
  Spinner, 
  Alert 
} from "reactstrap";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BackTo,
  Icon,
  Button,
  Row,
  Col,
  PreviewAltCard,
} from "../components/Component";
import { baseURLs } from '../utils/Constants';
import { getAxiosHeaders, getPhoneCodeAndNumber } from "../utils/Utils";
import { Link } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import { SuccessModal } from "./components/AlertModals";
import { Input, Select, InputNumber, Divider, Space, Form } from 'antd';
import PhoneNumberInput from "./components/PhoneNumberInput";
const { TextArea } = Input;

const EditSupplier = ({ history, match }) => {
  const [sm, updateSm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [requesting, setRequesting] = useState(false);
  const [businessID, setBusinessID] = useState("");
  const [supplierID, setSupplierID] = useState("");
  const [businessInfo, setBusinessInfo] = useState({});
  const [activeModal, setActiveModal] = useState(null);
  const [form] = Form.useForm();
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    supplier_name: '',
    phone_code: "+233",
    phone_number: '',
    email: '',
    supplier_other_info: '',
  });

  const toggleModal = (modal) => {
    if (activeModal === modal) {
      setActiveModal(null);
    } else {
      setActiveModal(modal);
    }
  };

  const handleFormSubmit = (_formData) => {
    setRequesting(true);
    setErrorMessage("");

    let phoneNumber = '';
    if(_formData.phone_code && _formData.phone_number){
      phoneNumber = `${_formData.phone_code}${_formData.phone_number?.replace(/^0+/, '')}`;
    }

    axios.put(baseURLs.API_URL + `/suppliers/edit/${supplierID}`, {
      business_id: businessID,
      supplier_name: _formData.supplier_name,
      phone_number: phoneNumber,
      email: _formData.email,
      supplier_other_info: _formData.supplier_other_info,
    }, getAxiosHeaders())
    .then((response) => {
      toggleModal("successModal");
      setRequesting(false);
    }).catch((error) => {

      setRequesting(false);

      try{
        let errorResponse = error.response.data;

        if(errorResponse.hasOwnProperty("errors")){
          form.setFields([
            {
              name: 'supplier_name',
              errors: errorResponse.errors.hasOwnProperty("supplier_name") ? [errorResponse.errors.supplier_name] : [],
            },
            {
              name: 'phone_number',
              errors: errorResponse.errors.hasOwnProperty("phone_number") ? [errorResponse.errors.phone_number] : [],
            },
            {
              name: 'email',
              errors: errorResponse.errors.hasOwnProperty("email") ? [errorResponse.errors.email] : [],
            },
            {
              name: 'supplier_other_info',
              errors: errorResponse.errors.hasOwnProperty("supplier_other_info") ? [errorResponse.errors.supplier_other_info] : [],
            }
          ]);

        }


        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        
      }catch(e){
        setErrorMessage("Error: Could not connect to server");
      }
    });
    
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  const onFinishFailed = (errorInfo) => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    console.log('Failed:', errorInfo);
  }

  const getSupplierInfo = (businessID, supplierID) => {

    axios.get(baseURLs.API_URL + `/suppliers/${supplierID}`, {
      params: {
        business_id: businessID
      },
      headers: getAxiosHeaders().headers
    })
    .then((response) => {
      if (response.status === 200) {
        let responseInfo = response.data;
        let supplierInfo = responseInfo.data.supplier_info;

        let phoneCode = formData.phone_code;
        let phoneNumber = '';

        if(supplierInfo.phone_number) {
          let phoneNumberFormatted = getPhoneCodeAndNumber(supplierInfo.phone_number);
          phoneCode = phoneNumberFormatted.phoneCode;
          phoneNumber = phoneNumberFormatted.phoneNumber;
        }
        
        // update form data 
        setFormData({
          supplier_name: supplierInfo.supplier_name,
          phone_code: phoneCode,
          phone_number: phoneNumber,
          email: supplierInfo.email ?? '',
          supplier_other_info: supplierInfo.other_info ?? '',
        })
        
        setLoading(false);
      }
    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        if(error.response.status === 401){
          history.push(`${process.env.PUBLIC_URL}/expired-session`);
          return;
        }

        if(error.response.status === 404){
          history.push(`${process.env.PUBLIC_URL}/not-found`);
          return;
        }

        if(error.response.status === 403){
          history.push(`${process.env.PUBLIC_URL}/unauthorized/b/${businessID}`);
          return;
        }

        if(error.response.status === 402){
          history.push(`${process.env.PUBLIC_URL}/subscription/b/${businessID}`);
          return;
        }

        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        setLoading(false);
      }catch(e){
        console.log(e);
        // history.push(`${process.env.PUBLIC_URL}/server-offline`);
      }
    });
  }

  useEffect(() => {
    setLoading(true);
    const businessID = parseInt(match.params.businessID, 10);
    const supplierID = parseInt(match.params.supplierID, 10);
    if ( !Number.isInteger(businessID) && !Number.isInteger(supplierID) ) {
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;      
    } 

    localStorage.setItem('current_business_id', businessID);
    let businesses = JSON.parse(localStorage.getItem('my_businesses'));
    let currentBusiness = businesses?.find((business) => business.business_id == businessID);
    
    if(currentBusiness == undefined || null || ""){
      history.push(`${process.env.PUBLIC_URL}/not-found`);
      return;
    }

    setBusinessInfo(currentBusiness);
    setBusinessID(businessID);
    setSupplierID(supplierID);
    getSupplierInfo(businessID, supplierID);
  }, [match.params.businessID]);


  return (<React.Fragment>
    <Head title="Edit Supplier" />
    <Content>
    {
      loading ?
      <Block className="nk-block-middle nk-auth-body text-center wide-xs">
        <div className="inner-pre-loader">
          <Spinner  color="dark" />          
        </div>
      </Block>
      :
      <>
        <BlockHead size="sm" className="wide-sm m-auto">
          <BlockHeadContent>
            <BackTo history={history} link={`${process.env.PUBLIC_URL}/suppliers/b/${businessID}`} icon="arrow-left">
              Go Back
            </BackTo>
            <BlockTitle tag="h2" className="fw-normal text-center mt-3">
              Edit a Supplier
            </BlockTitle>
            <BlockDes>
              <p className="text-center">Use the form below to update the supplier's information.</p>
            </BlockDes>
          </BlockHeadContent>
        </BlockHead>
        <Block className="wide-sm m-auto">
          {errorMessage && (
            <div className="mb-3">
              <Alert color="danger" className="alert-icon">
                {" "}
                <Icon name="alert-circle" /> {errorMessage}{" "}
              </Alert>
            </div>
          )}
        </Block>

        {/* success modal */}
        { 
          activeModal === "successModal" &&
          <SuccessModal showModal={true} toggleModal={() => toggleModal(null)}
            headerText={`Supplier Updated`} descriptionText={`The supplier's information has been updated successfully.`}
          />
        }

        <Block className="wide-sm m-auto">
          <Form name="create-warehouse"
            form={form} className="is-alter"
            initialValues={formData} 
            onFinish={handleFormSubmit}
            onFinishFailed={onFinishFailed}>
            <div className="card card-bordered">
              <div className="fm-head bg-lighter">
                <div className="fm-count"><Icon name="user-list fs-22px"></Icon></div>
                <div className="fm-title">
                  <h5 className="title fw-normal">Supplier Details</h5>
                  <p className="nk-block-des">Use the form below to update this supplier's information.</p>
                </div>
              </div>
              <div className="fm-content">
                <div className="row g-2">
                  <div className="col-md-12">
                    <div className="form-group">
                      <Form.Item>
                        <div className="form-label-group">
                            <label className="form-label">Supplier Name <span className="text-danger">*</span></label>
                        </div>
                        <Form.Item name={'supplier_name'}
                          noStyle
                          rules={[
                            {required: true,}
                          ]}>
                          <Input size="large" className="form-control form-control-lg" placeholder="Enter supplier name" />
                        </Form.Item>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="form-label-group">
                        <label className="form-label">Phone Number <span className="text-muted">(optional)</span></label>
                      </div>
                      <div className="form-control-wrap">
                        <PhoneNumberInput form={form} formData={formData} isRequired={false} setFormData={setFormData} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <Form.Item>
                        <div className="form-label-group">
                            <label className="form-label">Email <span className="text-muted">(optional)</span></label>
                        </div>
                        <Form.Item name={'email'}
                          noStyle
                          rules={[
                            {required: false}, {type: 'email', message: 'Email is invalid'}
                          ]}>
                          <Input size="large" type="email" className="form-control form-control-lg" placeholder="supplier@email.com" />
                        </Form.Item>
                      </Form.Item>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <Form.Item>
                        <div className="form-label-group">
                          <label className="form-label">Other Information <span className="text-muted">(optional)</span></label>
                        </div>
                        <div className="form-control-wrap">
                        <Form.Item name={'supplier_other_info'}
                          noStyle
                          rules={[
                            {required: false}
                          ]}>
                            <TextArea rows={4} placeholder="Other supplier information" />
                          </Form.Item>                       
                        </div>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fm-footer">
                <div className="pt-2 text-center">
                  <Button disabled={requesting} type="submit" color="primary" size="lg" >
                    {requesting ? <Spinner size="sm" color="light" /> : "Save"}
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </Block>
      </>
    }
    </Content>
    
  </React.Fragment>)
}

export default EditSupplier;